export default __webpack_public_path__ + "static/media/client_kumar.8ea4dc8c.jpeg";